import { render, staticRenderFns } from "./solutionsDetail.vue?vue&type=template&id=e54d9d64&scoped=true&"
import script from "./solutionsDetail.vue?vue&type=script&lang=js&"
export * from "./solutionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./solutionsDetail.vue?vue&type=style&index=0&id=e54d9d64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54d9d64",
  null
  
)

export default component.exports